import i18n from '@/i18n'
import { formatMoney, numberWithCommas } from '@/utils/NumericMutations'

const valueOrNotAvailable = (value) => {
  if (value === '' || value === null || value === undefined) {
    return i18n.t('notAvailable')
  }

  return value
}

export function glReconciliationHeaders () {
  return [
    {
      sortable: true,
      text: i18n.t('account'),
      value: 'accountName',
      align: 'left'
    },
    {
      sortable: true,
      text: i18n.t('exportCode'),
      value: 'exportCode',
      align: 'left',
      width: '20%',
      format: valueOrNotAvailable
    },
    {
      sortable: true,
      text: i18n.t('amount'),
      value: 'amount',
      align: 'right',
      width: '14%',
      format: formatMoney
    },
    {
      sortable: true,
      text: i18n.t('netTons'),
      value: 'netTons',
      align: 'right',
      width: '13%',
      format: x => numberWithCommas(x, 3)
    },
    {
      sortable: true,
      text: i18n.t('netMbf'),
      value: 'netMbf',
      align: 'right',
      width: '13%',
      format: x => numberWithCommas(x, 3)
    }
  ]
}
